import React, { useEffect } from 'react';
import './PolicyHeader.scss';
import { FocusTrap } from 'focus-trap-react';
import { SearchInput } from '../SearchInput/SearchInput';
import { useSearchContext } from '../../../providers/SearchProvider';
import { useLayoutContext } from '../../../providers/LayoutProvider';
import { SearchResults } from '../../SearchResults/SearchResults';
import { SearchTrigger } from '../SearchTrigger/SearchTrigger';
import { SidebarTrigger } from '../SidebarTrigger/SidebarTrigger';
import { Link } from 'gatsby';
import { useMainMenuData } from '../MainMenu/useMainMenuData';

interface PolciyHeaderProps {
    sidebarOpen: boolean;
    setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>;
    searchOpen: boolean;
    setSearchOpen: React.Dispatch<React.SetStateAction<boolean>>;
    searchInline?: boolean;
    refHeaderHeight?: number;
}

export const PolicyHeader = ({
    sidebarOpen,
    setSidebarOpen,
    searchOpen,
    setSearchOpen,
    searchInline,
    refHeaderHeight,
}: PolciyHeaderProps) => {
    const { loadSearch } = useSearchContext();
    const { policyNavRef } = useLayoutContext();
    const { policyNavItems } = useMainMenuData();

    useEffect(() => {
        if (searchInline) {
            setSearchOpen(true);
        }
    }, [searchInline]);

    useEffect(() => {
        loadSearch();
    }, []);

    return (
        <header className="policy-header nav-header" ref={policyNavRef}>
            <FocusTrap
                active={searchOpen && !searchInline}
                focusTrapOptions={{
                    allowOutsideClick: true,
                    clickOutsideDeactivates: true,
                    initialFocus: `#inputSearch`,
                }}
            >
                <section>
                    <div className="kite-container nav">
                        {!searchOpen && <h2>Public Policy</h2>}
                        {!searchOpen && (
                            <SidebarTrigger
                                sidebarOpen={sidebarOpen}
                                setSidebarOpen={setSidebarOpen}
                                searchOpen={searchOpen}
                            />
                        )}
                        {!searchOpen && (
                            <nav id={`public-policy-nav`}>
                                <ul id="public-policy-nav-list">
                                    {!!policyNavItems &&
                                        policyNavItems.map((navItem, idx) => {
                                            const index: number = idx + 1;
                                            const listItemId = `public-policy-nav-list-item-${index}`;
                                            const navLinkIId = `policy-nav-link-${index}`;
                                            return (
                                                <li
                                                    key={listItemId}
                                                    id={listItemId}
                                                >
                                                    <Link
                                                        id={navLinkIId}
                                                        to={navItem.url}
                                                        activeClassName="active"
                                                        partiallyActive={
                                                            navItem.url !== `/`
                                                        }
                                                    >
                                                        {navItem.title}
                                                    </Link>
                                                </li>
                                            );
                                        })}
                                </ul>
                            </nav>
                        )}
                        {!searchOpen && (
                            <SearchTrigger setSearchOpen={setSearchOpen} />
                        )}

                        {searchOpen && (
                            <SearchInput
                                searchOpen={searchOpen}
                                setSearchOpen={setSearchOpen}
                                searchInline={searchInline}
                            />
                        )}
                    </div>
                    {searchOpen && !searchInline && (
                        <div className="search-results">
                            <SearchResults
                                searchInline={searchInline}
                                setSearchOpen={setSearchOpen}
                                setSidebarOpen={setSidebarOpen}
                            />
                        </div>
                    )}
                </section>
            </FocusTrap>
        </header>
    );
};
